import contexts from './contexts';
import buildContextValidator from '../utils/schema/build/buildContextValidator';
import {guid} from '@servicenow/ui-internal';

export const prefix = guid();

export default function createContext(name, definition = {}) {
	const key = Symbol(`${prefix}_${name}`);
	contexts.set(key, {...definition, validate: buildContextValidator(definition.schema)});
	return key;
}
